function Error() {
  return (
    <p className="error">
      <span>💥</span> There was an error fecthing questions.
    </p>
    
  );
}

export default Error;

// 1. We useReducer function cause whenever we have multiple state variables all over place in a component. 
// 2. when one state update is depend on one or multiple state variables.
// 3. 